'use client';
import { clearLocalCart, resetServerCartInit } from './cart';

const SAVED_KEY = 'ennix_saved_later';

/**
 * Full logout: clears server session cookies, all localStorage cart/saved data,
 * and in-memory server cart state. Call this instead of hitting /api/auth/logout directly.
 */
export const logout = async () => {
    // 1. Expire session cookies on the server
    await fetch('/api/auth/logout', { method: 'POST' }).catch(() => {});

    // 2. Clear all cart localStorage keys (ennix_cart, ennix_cart_ids, ennix_cart_count)
    clearLocalCart();

    // 3. Clear saved-for-later
    if (typeof window !== 'undefined') {
        localStorage.removeItem(SAVED_KEY);
    }

    // 4. Reset in-memory server cart state so the next logged-in session starts fresh
    resetServerCartInit();

    // 5. Tell Google Identity Services to forget the auto-select account,
    //    so signing out here doesn't silently sign the user back in via One Tap.
    if (typeof window !== 'undefined' && window.google?.accounts?.id) {
        window.google.accounts.id.disableAutoSelect();
    }
};
